import React, { useEffect, useState } from 'react'
import "./Home.scss"
import { useLocation } from "react-router-dom"
import IllustrationBienvenida from "../../assets/img/ilustration-bienvenida.png"
import { jwtDecode } from "jwt-decode"
import { Modal } from "react-bootstrap";
import ListaConsultoras from '../../components/Home/ListaConsultoras'
import ListaEmpresas from '../../components/Home/ListaEmpresas'
import ListaAreas from '../../components/Home/ListaAreas'
import Laptop from '../../assets/img/laptop.png'

function Home() {
  const location = useLocation();

  const [modal, setModal] = useState(false);

  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const USER = jwtParse.apirest.objeto

  useEffect(() => {
    if (location.state?.codigo === 1 && !localStorage.getItem("modal2FA")) {
      // Activa el modal y lo guarda en localStorage
      setModal(true)
      localStorage.setItem("modal2FA", true)
    }
  }, [location.state]);

  const handleClose = () => setModal(false)

  const mensajeBienvenida = (
    <>
      <div className='section__header d-flex flex-row align-items-end mb-4'>
        <i className='bi bi-house-door-fill me-2'></i>
        <h4 className='m-0'>Dashboard</h4>
      </div>
      <div className='home__bienvenida d-flex flex-column flex-md-row rounded-3 align-items-md-center mb-4'>
        <div className='home__bienvenida__texto'>
          <h2 className='text-white m-0'><span>Bienvenido</span><br />{USER.nombre}</h2>
          {/* <p className='text-white m-0'>Tienes <b>{tareas}</b> tareas por realizar</p> */}
        </div>
        <div className='home__bienvenida__img d-flex align-self-end align-self-md-center'>
          <img className="position-relative" src={IllustrationBienvenida} alt="" />
        </div>
      </div>
    </>
  )

  return (
    <div className='home section'>
      {mensajeBienvenida}

      {USER.puesto === 1 && <ListaConsultoras />}
      {USER.puesto === 2 && <ListaEmpresas />}
      {USER.puesto >= 3 && USER.puesto <= 7 && <ListaAreas />}

      <Modal 
        show={modal} 
        onHide={handleClose} 
        centered 
        dialogClassName="msj2FA"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className='d-flex flex-column align-items-center justify-content-center'>
          <img className='mb-4' src={Laptop} alt='Usuario'/>
          <h3 className='text-blue-500 fw-medium text-center mb-3'>Activa protección Doble Factor</h3>
          <p className='m-0 mb-2 text-center'>Agrega más seguridad a tus proyectos activando protección Doble Factor.</p>
          <p className='m-0 mb-3 text-blue-500 text-center'>Ingresa a tu perfil y encontrarás el botón para activarlo.</p>
          <button onClick={handleClose} className='mt-4 btn btn-primary rounded-pill fw-medium px-4'>Cerrar</button>
        </Modal.Body>
      </Modal>

    </div>
  )
}

export default Home